import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * A token for skipping navigation on error in the UI for an HTTP context
 */
export const SKIP_NAVIGATION_ON_ERROR = new HttpContextToken<boolean>(() => false);

/**
 * Sets the SKIP_NAVIGATION_ON_ERROR flag in the given HTTP context
 *
 * @param context - The HTTP context to modify
 * @returns The modified HTTP context
 */
export const skipNavigationOnError = (context: HttpContext): HttpContext => context.set(SKIP_NAVIGATION_ON_ERROR, true);
